import { BASEURL } from "../Utils/EndPoint";
import {
  setAllUser,
  setChatList,
  setAllMessage,
  setStatus,
  setError,
} from "./chatReducer";
import axios from "axios";

export const fetchAllUsers = () => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const response = await axios.get(`${BASEURL}/api/user/alluser`);
    dispatch(setAllUser(response.data.data));
    dispatch(setStatus("succeeded"));
  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
  }
};

export const fetchChatList = () => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const response = await axios.get(`${BASEURL}/api/conversation/chat`);
    dispatch(setChatList(response.data.data));
    dispatch(setStatus("succeeded"));
  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
  }
};

export const fetchAllMessages = (receiverId) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const response = await axios.post(`${BASEURL}/api/message/allmessage`, { receiverId });
    dispatch(setAllMessage(response.data.data));
    dispatch(setStatus("succeeded"));
  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
  }
};

export const sendInvite = (receiverId) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    await axios.post(`${BASEURL}/api/conversation/sendinvite`, { receiverId });
    dispatch(setStatus("succeeded"));
    dispatch(fetchAllUsers());
    dispatch(fetchChatList());
  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
  }
};

export const sendMessage = (payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    await axios.post(`${BASEURL}/api/message/sendmessage`, payload);
    dispatch(fetchAllMessages(payload.receiverId));
    dispatch(setStatus("succeeded"));
  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
  }
};

export const clearChat = (payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    await axios.post(`${BASEURL}/api/message/deletemessage`, payload);
    dispatch(setStatus("succeeded"));
    dispatch(fetchAllMessages(payload.receiverId));
    dispatch(fetchChatList())
  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
  }
}


export const clearConversation = (payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    await axios.delete(`http://localhost:4000/api/conversation/chatdelete/${payload}`);
    dispatch(setStatus("succeeded"));
    dispatch(fetchChatList());
    dispatch(fetchAllUsers());

  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
  }
}

export const Register = (payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const res = await axios.post(`${BASEURL}/api/auth/register`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    dispatch(setStatus("succeeded"));
    return res

  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
    return error
  }
};

export const Login = (payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const res = await axios.post(`${BASEURL}/api/auth/login`, payload)
    dispatch(setStatus("succeeded"));
    return res

  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
    return error
  }
}

export const OtpSend = (payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const res = await axios.post(`${BASEURL}/api/auth/otpsend`, payload)
    dispatch(setStatus("succeeded"));
    return res

  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
    return error
  }
}

export const VerifyOtp = (payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const res = await axios.post(`${BASEURL}/api/auth/forgotpassword`, payload)
    dispatch(setStatus("succeeded"));
    return res

  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
    return error
  }
}

export const UpdatePassword = (payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const res = await axios.post(`${BASEURL}/api/auth/forgotpassword`, payload)
    dispatch(setStatus("succeeded"));
    return res

  } catch (error) {
    dispatch(setError(error.response?.data?.message  || error.message));
    dispatch(setStatus("failed"));
    return error
  }
}

export const UpdateProfile = (id,payload) => async (dispatch) => {
  dispatch(setStatus("loading"));
  try {
    const res = await axios.put(`${BASEURL}/api/auth/profileupdate/${id}`, payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
    dispatch(setStatus("succeeded"));
        
    return res

  } catch (error) {
        
    dispatch(setError(error.response?.data?.message ?.message || error.message));
    dispatch(setStatus("failed"));
    return error
  }
}

